import { render, staticRenderFns } from "./rappel-done.vue?vue&type=template&id=64a0272e"
import script from "./rappel-done.vue?vue&type=script&lang=ts"
export * from "./rappel-done.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a0272e')) {
      api.createRecord('64a0272e', component.options)
    } else {
      api.reload('64a0272e', component.options)
    }
    module.hot.accept("./rappel-done.vue?vue&type=template&id=64a0272e", function () {
      api.rerender('64a0272e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/rappel-done.vue"
export default component.exports